import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.16 2.96a3.958 3.958 0 1 1 3.423 6.707v1.466h1.375a.625.625 0 1 1 0 1.25H8.583v1.375a.625.625 0 1 1-1.25 0v-1.375H5.958a.625.625 0 1 1 0-1.25h1.375V9.667A3.958 3.958 0 0 1 5.16 2.96m2.798.09a2.708 2.708 0 1 0 0 5.417 2.708 2.708 0 0 0 0-5.417",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })